import Vue from 'vue'
import Router from 'vue-router'
import userInfoProvider from './services/userInfoProvider'
import loginService from "@/services/identity-authen/loginService"

Vue.use(Router)

function loginBeforeEnter(name: string = "") {
  return async (to, from, next) => {
    if (!loginService.getPrepareLoginResponse()) {
      return next({
        path: "/login/prepare",
        query: to.query,
      })
    }
    return next()
  }
}

const router = new Router({
  mode: 'history',
  base: "/user/",
  routes: [
    {
      path: '/',
      redirect: '/download'
    },
    {
      path: '/download',
      name: 'download',
      component: () => import('./views/download/Index.vue'),
      children: [
        {
          path: 'download',
          redirect: 'download'
        },
        {
          path: '/download',
          name: 'download',
          component: () => import('./views/download/Download.vue'),
        },
      ]
    },
    // {
    //   path: '/login',
    //   name: "login",
    //   component: () => import('./views/login/Index.vue'),
    //   children: [
    //     {
    //       path: "",
    //       redirect: (to) => {
    //         return {
    //           path: "prepare",
    //           query: to.query,
    //         }
    //       },
    //     },
    //     {
    //       path: "prepare",
    //       name: "prepare",
    //       component: () => import("./views/login/Prepare.vue"),
    //     },
    //     {
    //       path: "username-password",
    //       name: 'username-password',
    //       component: () => import("./views/login/Login.vue"),
    //       beforeEnter: loginBeforeEnter("username_password"),
    //     },
    //     {
    //       path: 'totp-login',
    //       name: 'totp-login',
    //       meta: { requiresAuth: true },
    //       component: () => import('./views/login/Totp.vue'),
    //       beforeEnter: loginBeforeEnter(),
    //     },
    //     {
    //       path: 'totp-reset',
    //       name: 'totp-reset',
    //       meta: { requiresAuth: true },
    //       component: () => import('./views/login/resetTOTP/ResetTOTP.vue'),
    //       beforeEnter: loginBeforeEnter(),
    //       children: [
    //         {
    //           path: 'no-phone',
    //           name: 'reset-totp-no-phone',
    //           component: () => import('./views/login/resetTOTP/NoPhoneNumber.vue')
    //         },
    //         {
    //           path: 'enter-phone',
    //           name: 'reset-totp-enter-phone',
    //           component: () => import('./views/login/resetTOTP/EnterPhoneNumber.vue')
    //         },
    //         {
    //           path: 'enter-otp',
    //           name: 'reset-totp-enter-otp',
    //           component: () => import('./views/login/resetTOTP/EnterOTP.vue')
    //         }
    //       ],
    //     },
    //     {
    //       path: 'email-otp-login',
    //       name: 'email-otp-login',
    //       meta: { requiresAuth: true },
    //       component: () => import('./views/login/EmailOtp.vue'),
    //       beforeEnter: loginBeforeEnter(),
    //     },
    //     {
    //       path: 'security_key',
    //       name: 'security_key',
    //       meta: { requiresAuth: true },
    //       component: () => import('./views/login/SecurityKey.vue'),
    //       beforeEnter: loginBeforeEnter(),
    //     },
    //     {
    //       path: 'sms-otp-login',
    //       name: 'sms-otp-login',
    //       meta: { requiresAuth: true },
    //       component: () => import('./views/login/SmsOtp.vue'),
    //       beforeEnter: loginBeforeEnter(),
    //     },
    //     {
    //       path: 'reset-password',
    //       name: 'reset-password',
    //       component: () => import('./views/change-password/ChangePassword.vue'),
    //     },
    //     {
    //       path: 'forgot-password',
    //       name: 'forgot-password',
    //       component: () => import('./views/login/forgot-password/ForgotPassword.vue'),
    //     },
    //     {
    //       path: 'forgot-password-otp',
    //       name: 'forgot-password-otp',
    //       component: () => import('./views/login/forgot-password/ForgotPasswordOTP.vue'),
    //     },
    //     {
    //       path: 'forgot-password-result',
    //       name: 'forgot-password-result',
    //       component: () => import('./views/login/forgot-password/ForgotPasswordResult.vue'),
    //     },
    //     {
    //       path: 'change-password',
    //       name: 'change-password-for-first-time',
    //       component: () => import('./views/login/forgot-password/ForgotPasswordOTP.vue'),
    //     },
    //     {
    //       path: 'request-unlock',
    //       name: 'request-unlock',
    //       component: () => import('./views/login/request-unlock/RequestUnlock.vue'),
    //     },
    //     {
    //       path: 'request-unlock-otp',
    //       name: 'request-unlock-otp',
    //       component: () => import('./views/login/request-unlock/RequestUnlockOTP.vue'),
    //     },
    //     {
    //       path: 'request-unlock-success',
    //       name: 'request-unlock-success',
    //       component: () => import('./views/login/request-unlock/UnlockSuccess.vue'),
    //     },
    //   ]
    // },
    // {
    //   path: '/app',
    //   component: () => import('./views/Layout.vue'),
    //   children: [
    //     {
    //       path: '',
    //       name: 'app',
    //       redirect: 'change-password'
    //     },
    //     {
    //       path: '/change-password',
    //       name: 'change-password',
    //       meta: { requiresAuth: true },
    //       component: () => import('./views/change-password/Index.vue'),
    //       children: [
    //         {
    //           path: 'change-password',
    //           redirect: 'change-password'
    //         },
    //         {
    //           path: '/change-password',
    //           name: 'change-password',
    //           component: () => import('./views/change-password/ChangePassword.vue'),
    //         },
    //       ]
    //     },
    //     {
    //       path: '/application',
    //       name: 'application',
    //       meta: { requiresAuth: true },
    //       component: () => import('./views/ssh-server/Index.vue'),
    //       children: [
    //         {
    //           path: 'application',
    //           redirect: 'application'
    //         },
    //         {
    //           path: '/application',
    //           name: 'application',
    //           component: () => import('./views/application/Application.vue'),
    //         },
    //       ]
    //     },
    //     {
    //       path: '/dashboard',
    //       name: 'dashboard',
    //       meta: { requiresAuth: true },
    //       component: () => import('./views/dashboard/Index.vue'),
    //       children: [
    //         {
    //           path: 'dashboard',
    //           redirect: 'dashboard'
    //         },
    //         {
    //           path: '/dashboard',
    //           name: 'dashboard',
    //           component: () => import('./views/dashboard/Dashboard.vue'),
    //         },
    //       ]
    //     },
    //     {
    //       path: '/mfa-management',
    //       name: 'mfa-management',
    //       meta: { requiresAuth: true },
    //       component: () => import('./views/mfa-management/Index.vue'),
    //       children: [
    //         {
    //           path: 'mfa-management',
    //           redirect: 'mfa-management'
    //         },
    //         {
    //           path: '/mfa-management',
    //           name: 'mfa-management',
    //           component: () => import('./views/mfa-management/MFAManagement.vue'),
    //         },
    //       ]
    //     },
    //     {
    //       path: '/ssh-server',
    //       name: 'ssh-server',
    //       meta: { requiresAuth: true },
    //       component: () => import('./views/ssh-server/Index.vue'),
    //       children: [
    //         {
    //           path: 'ssh-server',
    //           redirect: 'ssh-server'
    //         },
    //         {
    //           path: '/ssh-server',
    //           name: 'ssh-server',
    //           component: () => import('./views/ssh-server/SSHServer.vue'),
    //         },
    //       ]
    //     },
    //     {
    //       path: 'terminal',
    //       meta: { requiresAuth: true },
    //       component: () => import('./views/terminal/Index.vue'),
    //       children: [
    //         {
    //           path: "",
    //           redirect: 'connection'
    //         },
    //         {
    //           path: "connection",
    //           name: 'connection',
    //           component: () => import("./views/terminal/connection/Index.vue"),
    //         }
    //       ]
    //     },
    //     {
    //       path: '/assign-request',
    //       name: 'assign-request',
    //       meta: { requiresAuth: true },
    //       component: () => import('./views/assign-request/Index.vue'),
    //       children: [
    //         {
    //           path: 'assign-request',
    //           redirect: 'assign-request'
    //         },
    //         {
    //           path: '/assign-request',
    //           name: 'assign-request',
    //           component: () => import('./views/assign-request/AssignRequest.vue'),
    //         },
    //       ]
    //     },
    //   ],
    // },
    {
      path: "/help",
      component: () => import("@/views/help/Index.vue"),
      children: [
        {
          path: '',
          redirect: 'index'
        },
        {
          path: 'index',
          component: () => import("@/views/help/_partials/Help.vue"),
        },
        {
          path: "contact",
          component: () => import("@/views/help/_partials/Contact.vue"),
        },
        {
          path: "search",
          component: () => import("@/views/help/_partials/Search.vue"),
        },
      ],
    },
    {
      path: "/user-guide",
      component: () => import("@/views/user-guide/Index.vue"),
      children: [
        {
          path: '',
          redirect: 'index'
        },
        {
          path: "index",
          component: () => import("@/views/user-guide/_partials/UserGuide.vue"),
        },
        {
          path: "contact",
          component: () => import("@/views/user-guide/_partials/Contact.vue"),
        },
        {
          path: "search",
          component: () => import("@/views/user-guide/_partials/Search.vue"),
        },
      ]
    },
    {
      path: "**",
      redirect: '/download'
    }
  ],
})

router.beforeEach(async (to, from, next) => {
  const pathDefault = "/mfa-management"
  if (to.query && to.query.access_token && to.fullPath.includes(pathDefault)) {
    await userInfoProvider.setAccessToken(to.query.access_token, false);
  }
  const isAuthenticated = userInfoProvider.getAccessToken()
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})


export default router
